<div
  class="container"
  [class.enabled]="!disabled"
>
  <div class="content">
    <div
      class="toggle-icon"
      (click)="onClick(!selected)"
    >
      @if (selected && !disabled) {
        <payee-icon [name]="'toggle-on'"></payee-icon>
      }
      @if (!selected && !disabled) {
        <payee-icon name="toggle-off"></payee-icon>
      }
      @if (selected && disabled) {
        <payee-icon name="toggle-on-disabled"></payee-icon>
      }
      @if (!selected && disabled) {
        <payee-icon name="toggle-off"></payee-icon>
      }
    </div>
    @if (text) {
      <payee-icon
        class="add-claim-icon"
        name="add-claim"
      ></payee-icon>
    }
    <div
      class="text"
      [class.selected]="selected"
    >
      {{ text }}
    </div>
  </div>
</div>
